import { combineReducers } from 'redux';
import settingsReducer from './settingsReducer';
import constantsReducer from './constantsReducer';
import isMobileReducer from './isMobileReducer';
import designReducer from './designReducer';
import faqListReducer from './faqListReducer';
import styleParamsReducer from './styleParamsReducer';

export default combineReducers({
  settings: settingsReducer,
  design: designReducer,
  constants: constantsReducer,
  isMobile: isMobileReducer,
  styleParams: styleParamsReducer,
  faqList: faqListReducer,
});
